<div mat-dialog-content>
    {{Titulo}}
</div>
<div mat-dialog-actions>
    <button mat-flat-button color="primary-darker" (click)="respuesta(true)">{{Etiquetas.Si}}</button>
    <button mat-flat-button color="accent-darker" (click)="respuesta(false)">{{Etiquetas.No}}</button>
</div>